import React from 'react';
import { ButtonPrimary } from '../../Buttons';
import Table from '../Table';
import { useAuth } from '../../../contexts/AuthContext';
import toast from 'react-hot-toast';

const DownloadFilesTable = ({ filenames, serialNumber }) => {
  const { getAuthenticatedFile } = useAuth();

  const downloadFile = async (filename) => {
    try {
      const fileBlob = await getAuthenticatedFile(
        `/devices/${serialNumber}/update-files?name=${filename}`
      );

      // Create a URL for the Blob
      const url = window.URL.createObjectURL(fileBlob);

      // Create an anchor element and trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = filename; // Set the file name for the download
      document.body.appendChild(a);
      a.click();

      // Clean up and remove the anchor element
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Failed to download file:', e);
      toast.error('Failed to get update file');
    }
  };

  const headers = ['Filename', 'Download'];
  const rows = filenames.map((filename) => [
    <span className="font-bold">{filename}</span>,
    <ButtonPrimary onClick={() => downloadFile(filename)}>
      Download
    </ButtonPrimary>,
  ]);

  return (
    <Table className="w-full max-h-[400px]" headers={headers} rows={rows} />
  );
};

export default DownloadFilesTable;
